import { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import PropTypes from 'prop-types';

import { ResetPassword } from '../../services/users';
import { setAnalytics } from '../../utils';
import TransitionsModal from '../General/TransitionsModal';

const useStyles = makeStyles((theme) => ({
  titleForm: {
    fontWeight: 'normal',
    fontSize: 16,
    color: theme.palette.common.blue,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(3),
  },
  titleSession: {
    fontWeight: 600,
    fontSize: 24,
    color: theme.palette.common.blue,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(5),
  },
  sectionDivider: {
    background: theme.palette.common.pink,
    size: '5',
    margin: theme.spacing(1, 1, 1),
    borderBottomWidth: 4,
  },
  input: {
    border: `1px solid ${theme.palette.background.primary}`,
    borderRadius: 'px',
    background: theme.palette.background.default,
    [theme.breakpoints.down('md')]: {
      width: '210px',
    },
    [theme.breakpoints.up('md')]: {
      width: '300px',
    },
    marginTop: theme.spacing(1),
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  error: {
    color: theme.palette.common.red,
    margin: '5px',
  },
  forget: {
    fontWeight: 'normal',
    fontSize: 14,
    color: theme.palette.text.alert,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(2),
  },
  icon: {
    color: 'gray',
  },
  submit: {
    color: theme.palette.background.default,
    boxShadow: theme.shadows[1],
    fontWeight: '400',
    marginTop: theme.spacing(8),
    textTransform: 'capitalize',
    padding: '6px 30px',
    background: theme.palette.background.secondary,
    fontSize: 16,
    fontFamily: 'Raleway',
    '&:hover': {
      background: theme.palette.common.pinkLigth,
    },
    '&:disabled': {
      background: theme.palette.common.gray,
    },
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  textError: {
    color: theme.palette.common.red,
    marginTop: theme.spacing(4),
  },
}));

function PasswordForget({ setIsForgotPassword, setName }) {
  const classes = useStyles();
  const [errorText, setErrorText] = useState('');
  const [openModalCode, setOpenModalCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    typeDocument: '',
    document: '',
  });
  const [longValidUser, setlongValidUser] = useState(true);

  const getMessageError = (error) => {
    const errors = {
      'User does not exist.': 'Tu documento es incorrecto o no está registrado',
      default: 'Lo sentimos, ocurrió un error',
    };

    return errors[error] || errors.default;
  };

  const recover = async () => {
    try {
      setLoading(true);
      await ResetPassword(values.document);
      setLoading(false);
      setOpenModalCode(true);
    } catch (error) {
      console.log(error.message);
      const messageError = getMessageError(error.message);
      setErrorText(messageError);
      setLoading(false);
    }
  };

  const closeModalCode = () => {
    setOpenModalCode(false);
  };

  const handleChangePassword = (event) => {
    setlongValidUser(true);
    if (event.target.name === 'document' && event.target.value.length < 8) {
      setlongValidUser(false);
    }
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleClose = () => {
    setOpenModalCode(false);
    setIsForgotPassword(false);
    setName(values.document);
  };
  const styleIconModal = (e) => (<CheckCircleOutlineRoundedIcon className={e} />);

  useEffect(() => {
    setAnalytics('Login', 'Btn_OlvideMiContraseña');
  }, []);

  return (
    <>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <span className={classes.titleSession}>Recuperar contraseña</span>
      </Grid>
      <Divider className={classes.sectionDivider} variant="middle" />
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <FormControl>
          <span className={classes.titleForm}>Usuario</span>
          <OutlinedInput
            className={classes.input}
            placeholder="Ingresa tu DNI/C.E"
            id="document"
            type="number"
            name="document"
            onChange={(event) => {
              handleChangePassword(event);
            }}
            margin="dense"
            value={values.document}
          />
        </FormControl>
        <FormControl>
          {errorText && (
            <Typography variant="caption" className={classes.textError}>
              {errorText}
            </Typography>
          )}
        </FormControl>
        <FormControl>
          <Button
            type="submit"
            size="large"
            className={classes.submit}
            onClick={recover}
            open={openModalCode}
            onClose={closeModalCode}
            disabled={!(values.document && longValidUser)}
          >
            ENVIAR
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Button>
        </FormControl>
        <TransitionsModal
          open={openModalCode}
          handleClose={handleClose}
          textBody="Hemos enviado un código a
          tu correo corporativo"
          icon={styleIconModal}
        />
      </Grid>
    </>
  );
}

PasswordForget.propTypes = {
  setIsForgotPassword: PropTypes.string.isRequired,
  setName: PropTypes.string.isRequired,
};

export default PasswordForget;
